import { createSelector } from 'reselect';

import * as reducer from './common.reducer';
import { AppState } from '../state';

export const getState = (state: AppState) => state.common;

export const getPostListLoading = createSelector(getState, reducer.getPostListLoading);
export const getPostListFailData = createSelector(getState, reducer.getPostListFailData);
export const getPostListData = createSelector(getState, reducer.getPostListData);
export const getPostListDataAmount = createSelector(getState, reducer.getPostListDataAmount);

export const getPostItemLoading = createSelector(getState, reducer.getPostItemLoading);
export const getPostItemData = createSelector(getState, reducer.getPostItemData);
export const getPostItemFailData = createSelector(getState, reducer.getPostItemFailData);

export const removePostItemLoading = createSelector(getState, reducer.removePostItemLoading);
export const removePostItemData = createSelector(getState, reducer.removePostItemData);
export const removePostItemFailData = createSelector(getState, reducer.removePostItemFailData);

export const createPostItemLoading = createSelector(getState, reducer.createPostItemLoading);
export const createPostItemData = createSelector(getState, reducer.createPostItemData);
export const createPostItemFailData = createSelector(getState, reducer.createPostItemFailData);

export const updatePostItemLoading = createSelector(getState, reducer.updatePostItemLoading);
export const updatePostItemData = createSelector(getState, reducer.updatePostItemData);
export const updatePostItemFailData = createSelector(getState, reducer.updatePostItemFailData);

export const getCategoryItemLoading = createSelector(getState, reducer.getCategoryItemLoading);
export const getCategoryItemData = createSelector(getState, reducer.getCategoryItemData);
export const getCategoryItemFailData = createSelector(getState, reducer.getCategoryItemFailData);

export const getCategoryListLoading = createSelector(getState, reducer.getCategoryListLoading);
export const getCategoryListData = createSelector(getState, reducer.getCategoryListData);
export const getCategoryListFailData = createSelector(getState, reducer.getCategoryListFailData);

export const createTagItemLoading = createSelector(getState, reducer.createTagItemLoading);
export const createTagItemData = createSelector(getState, reducer.createTagItemData);
export const createTagItemFailData = createSelector(getState, reducer.createTagItemFailData);

export const updateTagItemLoading = createSelector(getState, reducer.updateTagItemLoading);
export const updateTagItemData = createSelector(getState, reducer.updateTagItemData);
export const updateTagItemFailData = createSelector(getState, reducer.updateTagItemFailData);

export const removeTagItemLoading = createSelector(getState, reducer.removeTagItemLoading);
export const removeTagItemData = createSelector(getState, reducer.removeTagItemData);
export const removeTagItemFailData = createSelector(getState, reducer.removeTagItemFailData);

export const getTagItemLoading = createSelector(getState, reducer.getTagItemLoading);
export const getTagItemData = createSelector(getState, reducer.getTagItemData);
export const getTagItemFailData = createSelector(getState, reducer.getTagItemFailData);

export const getTagListLoading = createSelector(getState, reducer.getTagListLoading);
export const getTagListData = createSelector(getState, reducer.getTagListData);
export const getTagListFailData = createSelector(getState, reducer.getTagListFailData);

export const removeImageFromPostLoading = createSelector(getState, reducer.removeImageFromPostLoading);
export const removeImageFromPostData = createSelector(getState, reducer.removeImageFromPostData);
export const removeImageFromPostFailData = createSelector(getState, reducer.removeImageFromPostFailData);